import StringsBase from 'localization/StringsBase';

export default class StringsJa extends StringsBase{
    static get Disclaimer() {return Disclaimer;}
    static get Welcome() {return Welcome;}
    static get StatModelMoreInfo() {return StatModelMoreInfo;}
    static get MoreInfo() {return MoreInfo;}
    static get General() {return General;}
    static get Loss() {return Loss;}
    static get Age() {return Age;}
    static get Sound() {return Sound;}
    static get Telephone() {return Telephone;}
    static get Quiet() {return Quiet;}
    static get Effort() {return Effort;}
    static get Summary() {return Summary;}
    static get Searching() {return Searching;}
    static get Results() {return Results;}
    static get MarketingPanel() {return MarketingPanel;}
}

const General = { 
    Logout: "サインアウト", // Sain auto (Sign out)
    Next: "次へ", // Tsugi e (Next)
};

const Disclaimer = { 
    Disclaimer: "「スタート」ボタンを押すことにより、以下に同意したものとします：(i)本サービスは診断や治療に関する推奨事項を提供するものではなく、当社と患者との間に医療従事者としての関係を構築するものではありません。(ii)本サービスを通じて提供されるあらゆる情報、資料、結果、データの解釈、患者または潜在的な患者に対する当社の製品、サービス、またはその他の医療サービスの必要性の評価、ならびに当該患者への関連する医療アドバイスの提供については、すべて医療従事者単独の責任で実施します。",
    // By pressing Start, You acknowledge that (i) the Services do not provide a diagnosis or other recommendation for treatment or form a healthcare professional relationship between us and any Patient; and (ii) You are solely responsible for interpretation of any information, materials, results or data made available through the Services, the assessment of a Patient’s or potential Patient’s need for our products, Services, or other health care services, and the provision of any related medical advice to such Patient;
};

const Welcome = { 
    WelcomeTitle: "ようこそ", // Yōkoso (Welcome)
    ToolTitle: "紹介サポートツール", // Shōkai sapōto tsūru (Referral Support Tool)
    DescriptionLine1: "<span class='smoke100'>このツールは、</span> </br><span class='smoke180'>聴覚専門医が患者さまと一緒に人工内耳について話し合う際に役立つサポートツールです。</span>",
    // This tool is intended to be used by a hearing clinician with your patient present to support a conversation about cochlear implants.
    DescriptionLine2: "<span class='smoke100'></span><span class='smoke180'>6つの質問に回答するのに約1分、</span><span class='smoke100'>その後、</br>表示された情報について話し合うのに</br>約3〜5分かかります。</span>",
    // It will take about 1 minute to answer 6 questions and approximately 3-5 minutes to have a conversation about the information displayed.
    StartButton: "スタート", // Sutāto (Start)
    MoreInfoButton: "詳細を確認する", // Shōsai o kakunin suru (Find out more)
};

const StatModelMoreInfo = { 
    Title: "紹介サポートツールについて", // Shōkai sapōto tsūru ni tsuite (About Referral Support Tool)
};

const Age = { 
    Title: "聴覚プロフィール", // Chōryoku purofīru (Hearing profile)
    Description: "患者さまに近い年齢層を選択してください。", // Kanja-sama ni chikai nenrei-sō o sentaku shite kudasai. (Choose an age group similar to your patient.)
    ButtonSmallerThan50: "50歳未満", // 50-sai miman (<50)
    Button50To60: "50-60歳", // 50-60-sai (50-60)
    Button60To70: "60-70歳", // 60-70-sai (60-70)
    Button70To80: "70-80歳", // 70-80-sai (70-80)
    Button80Plus: "80歳以上", // 80-sai ijō (80+)
};

const Loss = { 
    Title: "聴覚プロフィール", // Chōryoku purofīru (Hearing profile)
    Description: "患者さまに近い難聴の程度を選択してください。", // Kanja-sama ni chikai nanchō no teido o sentaku shite kudasai. (Choose a degree of hearing loss similar to your patient.)
    ExtraDescription: "検討対象の耳", // Kentō-chū no mimi (Ear under consideration)
    SeverPlain: "60-80 dBHL",
    SevereToProfoundPlain: "80-90 dBHL", 
    ProfoundPlain: "90-100 dBHL",
    VeryProfoundPlain: "100+ dBHL",
    Severe: "60-80 dBHL",
    SevereToProfound: "80-90 dBHL",
    Profound: "90-100 dBHL",
    VeryProfound: "100+ dBHL",

    PureToneAverage: "平均聴力レベル:", // Heikin chōryoku reberu (Pure tone average:)
    AidedCncScore: "補聴器装用下における推定語音聴取能:", // Suitei hochōki sōyō-ka CNC goon meiryōdo sukoa han'i (Estimated aided word score range:)
    BinauralEstimatedRange: "両耳補聴器装用下における推定語音聴取能:", // Suitei ryōmimi hochōki sōyō-ka goon meiryōdo sukoa han'i (Estimated binaural aided word score range:)
    PTAModerate: "40dBHLから60dBHL", // 40dBHL kara 60dBHL
    PTASevere: "60dBHLから80dBHL", // 60dBHL kara 80dBHL
    PTASevereToProfound: "80dBHLから90dBHL", // 80dBHL kara 90dBHL
    PTAProfound: "90dBHLから100dBHL", // 90dBHL kara 100dBHL
    PTAVeryProfound: "100dBHL超", // 100dBHL chō (Over 100dBHL)
    ACSModerate: "9%から69%", // 9% kara 69%
    ACSSevere: "9%から44%", // 9% kara 44%
    ACSSevereToProfound: "8%から36%", // 8% kara 36%
    ACSProfound: "0%から26%", // 0% kara 26%
    ACSVeryProfound: "0%から12%", // 0% kara 12%
    BEASever: "23%から55%", // 23% kara 55%
    BEASevereToProfound: "22%から48%", // 22% kara 48%
    BEAProfound: "15%から39%", // 15% kara 39%
    BEAVeryProfound: "15%から26%", // 15% kara 26%  
};

const Sound = { 
    Title: "会話中の聴こえの質（補聴器装用時）", // Kaiwa-chū no chōkaku no meiryōdo (hochōki sōyō-ji) (Quality of hearing during conversations (with hearing aids))
    Description: "患者さまに次の質問をしてください。「人の声は、はっきり自然に聞こえますか？」", // Kanja-sama ni, hoka no hito no koe ga kuria de shizen ni kikoeru ka tazunete kudasai. (Ask your patient, do other people's voices sound clear and natural?)
    Groups: ["まったくない", // Mattaku nai (Not at all)
            "めったにない", // Mettani nai (Rarely)
            "時々", // Tokidoki (Sometimes)
            "しばしば", // Shibashiba (Often)
            "完全に"] // Kanzen ni (Perfectly)
};

const Effort = { 
    Title: "会話中の傾聴努力（補聴器装用時）", // Kaiwa-chū no chōkaku no yōi-sa (hochōki sōyō-ji) (Ease of hearing during conversations (with hearing aids))
    Description: "患者さまに次の質問をしてください。「人と会話をするとき、話の内容を聴き取るためにかなり努力する必要がありますか？」", // Kanja-sama ni, hoka no hito to no kaiwa de, iwareta koto o kiku tame ni tadaina doryoku ga hitsuyō ka tazunete kudasai. (Ask your patient, do you have to put in a lot of effort to hear what has been said in conversation with others?)
    Groups: ["多大な努力が必要", // Tadaina doryoku ga hitsuyō (A lot of effort)
        "しばしば", // Shibashiba (Often)
        "時々", // Tokidoki (Sometimes)
        "めったにない", // Mettani nai (Rarely)
        "努力は不要"] // Doryoku wa fuyō (No effort)
};

const Telephone = { 
    Title: "電話での会話（補聴器装用時）", // Denwa de no kaiwa (hochōki sōyō-ji) (Having a telephone conversation (with hearing aids))
    Description: "患者さまに次の質問をしてください。「あなたは、電話で話を問題なく聴き取ることができますか？」", // Kanja-sama ni, denwa de kantan ni kaiwa dekiru ka tazunete kudasai. (Ask your patient, can you easily have a conversation on the telephone?)
    Groups: ["まったくできない", // Mattaku nai (Not at all)
            "めったにない", // Mettani nai (Rarely)
            "時々", // Tokidoki (Sometimes)
            "しばしば", // Shibashiba (Often)
            "完全にできる"] // Kanzen ni (Perfectly)
};

const Quiet = { 
    Title: "静かな部屋での１対１の会話（補聴器装用時）", // Shizuka na heya de no 1 tai 1 no kaiwa (hochōki sōyō-ji) (Having a 1:1 conversations in a quiet room (with hearing aids))
    Description: "患者さまに次の質問をしてください。「あなたは、カーペットが敷かれた静かな部屋で１対１の会話をしています。相手の言うことがわかりますか？」", // Kanja-sama ni, shizuka de kāpetto ga shika reta raunji rūmu de hoka no hito to ittaiichi de hanashite iru baai, aite no iu koto o kikitore ru ka tazunete kudasai. (Ask your patient, you are talking with one other person in a quiet, carpeted lounge room. Can you follow what the other person says?)
    Groups: ["まったくわからない", // Mattaku nai (Not at all)
            "めったにない", // Mettani nai (Rarely)
            "時々", // Tokidoki (Sometimes)
            "しばしば", // Shibashiba (Often)
            "完全にわかる"] // Kanzen ni (Perfectly)
};
const Searching = { 
    Description: "聴覚プロフィールに一致する人々をデータベースで検索しています..." // Chōkaku purofīru ni icchi suru hitobito o dētabēsu de kensaku shite imasu... (Searching database for people matching your hearing profile...)
};

const Summary = {
    CurrentStatus: "あなたの現在の聴覚プロフィール", // Anata no genzai no chōkaku purofīru (Your current hearing profile)
    YearsOld: "歳", // Sai (years old)
    ClearAndNatural: "明瞭で自然な聴こえ", // Kuria de shizen (Clear and natural)
    Effort: "傾聴努力", // Doryoku (Effort)
    TelephoneConversation: "電話での会話", // Denwa de no kaiwa (Telephone conversation)
    OoOConversation: "１対１の会話", // 1 tai 1 no kaiwa (1:1 conversation)
    NoticeTitle: "あなたは...", // Anata wa... (Have you noticed that you...)
    noticeItem1: "社交的な場面から遠ざかっていませんか？", // Shakō-teki na bamen kara tōzakatte imasen ka? (Are withdrawing from social situations?)
    noticeItem2: "読話で疲れたりストレスを感じたりしていませんか？", // Dokushinjutsu de tsukare tari sutoresu o kanji tari shite imasen ka? (Are tired and stressed from lip reading?)
    noticeItem3: "騒がしい部屋で人の話がよく聞こえるように座る位置を考慮する必要がありませんか？", // Sawagashī heya de yori kikitotoru tame ni jibun no ichi o kōryō shinakereba narimasen ka? (Have to consider their position in a noisy room to hear better?)
    noticeItem4: "聴き取りを助けてもらうためにパートナーに大きく頼っていませんか？", // Chōkaku sapōto o pātonā ni ōkiku tayotte imasen ka? (Rely heavily on their partner for hearing support?)
}

const Results = { 
    You:"あなた", // Anata (You)
    After:"装用後", // Nochi (After)
    OneOnOneConversation: "１対１の会話", // 1 tai 1 no kaiwa (One on one conversation)
    Phone: "電話", // Denwa (Phone)
    EffortOfHearing: "聴き取りの容易さ", // Kikitōri no yōi-sa (Ease of hearing)

    RibbonBasedOn: "現在の", // Ika ni motozuki (Based on)
    RibbonYou: "あなた", // Anata (You)
    RibbonText: "<span class='smoke100'>の情報に基づき、</span> <span class='smoke180'>人工内耳装用者1,500件以上の記録を、</span> <span class='smoke100 sub-heading2'>人工内耳装用後12ヶ月の時点</span> <span class='smoke100'>で検索しました</span>",
    // we have searched over 1,500 cochlear implant recipient records, 12 months after receiving a cochlear implant

    SpeechTestTitle: "両耳装用下における語音聴取能の推定値", // Ryōmimi sōyō-ka goon meiryōdo sukoa no suitei-chi (Binaural speech test word score estimates)
    SpeechTestDescription: "人工内耳手術後の装用下CNC単語スコア（90%予測区間）", // Jutsugo hochōki sōyō-ka CNC goon meiryōdo sukoa (90% yosoku kukan) (Postoperative aided CNC word score (90% prediction interval))
    SpeechTestBody: "<span class='smoke180 body1'>あなたと同じような条件の人の</span> </br><span class='over-heading1 lavender120'>${}%</span> </br> <span class='smoke180 body1'>以上で</span> </br> <span class='over-heading1 lavender120 wide-line-height'>人工内耳装用後に</br>語音の聴き取りが</br>向上しました</span> <span class='smoke180 body1'></span>",
    // Over ${}% of people like you improved speech recognition after receiving a cochlear implant

    ClarityTitle: "会話中の聴こえの明瞭度", // Kaiwa-chū no chōkaku no meiryōdo (Clarity of hearing during conversations)
    ClarityBody: "<span class='smoke180 body1'>あなたと同じような条件の人が </span> </br> <span class='over-heading1 lavender120 wide-line-height'>人工内耳</br>装用後に</span> </br> <span class='smoke180 body1'> 聴こえの </span> </br> <span class='over-heading1 lavender120 wide-line-height'> 明瞭度 </span> </br> <span class='smoke180 body1'> を向上させました</span>",
    // People like you improved their clarity of hearing after receiving a cochlear implant

    OoOTitle: "１対１の会話", // 1 tai 1 no kaiwa (Have a one on one conversation)
    OoOBody: "<span class='caption1 smoke100'> 人工内耳装用者の </span> <span class='over-heading1 lavender120'> ${}% </span><br/><span class='caption1 smoke100'> 以上が </span><br/> <span class='sub-heading1 lavender120'> １対１の会話が改善 </span> <span class='caption1 smoke100'> したと報告しています</span>",
    // Over ${}% of recipients reported improved one on one conversations

    PhoneTitle: "電話での会話", // Denwa de no kaiwa (Have a conversation on the phone)
    PhoneBody: "<span class='caption1 smoke100'> 人工内耳装用者の </span> <span class='over-heading1 lavender120'> ${}% </span><br/> <span class='caption1 smoke100'> 以上が </span><br/> <span class='sub-heading1 lavender120'> 電話での会話が改善 </span> <span class='caption1 smoke100'> したと報告しています </span>",
    // Over ${}% of recipients reported having better phone conversations

    EaseTitle: "会話中の聴き取りの容易さ", // Kaiwa-chū no chōkaku no yōi-sa (Ease of hearing during conversations)
    EaseBody: "<span class='caption1 smoke100'> 人工内耳装用者の </span> <span class='over-heading1 lavender120'> ${}% </span><br/> <span class='caption1 smoke100'> 以上が </span><br/> <span class='sub-heading1 lavender120'> 聴き取りが楽</span> <span class='caption1 smoke100'> になったと報告しています </span>",
    // Over ${}% of recipients reported easier to hear

    LegendWordScoreYou: "<span class='smoke100'>選択内容に基づき、あなたの術前の語音聴取能は</span><span class='smoke180 sub-heading2'> ${}% </span><span class='smoke100'>と推定されました。</span>",
    // Based on the selection, a likely pre-operative word score recognition of ${}% has been estimated.

    LegendWordScoreAfter: "<span class='smoke180 sub-heading2'>人工内耳装用者の${}%</span> <span class='smoke100'>において、装用後12ヶ月時点のスコアが</span><span class='smoke180 sub-heading2'>${}%から${}%</span><span class='smoke100'>に改善しました（上に示すとおり）。",
    // ${}% of recipients improved to a score of between ${}% and ${}% 12 months after receiving a cochlear implant as shown above.

    LegendSsqClarityYou: "<span class='smoke100'>あなたの術前の聴こえの明瞭度スコアは </span><span class='smoke180 sub-heading2'> ${} </span><span class='smoke100'>が選択されました</span>",
    // Based on you, a preoperative clarity score of ${} was selected

    LegendSsqClarityAfter: "<span class='smoke100'>すべての装用者の結果が表示されます。スケールは0から10で、0は「不明瞭」、10は「明瞭で自然」を意味します</span>",
    // Results of all recipients are shown, on a scale of 0-10 with 0 being unclear and 10 being clear and natural

    InfoSmallCardsGreen: "あなたの術前の「${}」スコアは${}が選択されました。", // Based on you, a preoperative ${} score of ${} was selected.
    InfoSmallCardsPurple: "結果は、あなたが選択したスコアより良好であると自己評価した人工内耳装用者の割合を示しています。", // Results display the proportion of cochlear implant recipients that scored themselves as performing better than your selection.

    Unclear: "**不明瞭**", // Fumeiryō (Unclear)
    ClearAndNatural: "**明瞭で自然**", // Kuria de shizen (Clear and natural)
}

const MarketingPanel = {
    Title: "患者さまは、次のことができると感じていますか", // Anata no kanja-sama wa, tsugi no koto ni kizuite imasu ka (Has your client noticed that they)
    AlertDescription: "アラームや<br/>警告音が聞こえる", // Arāto ya keikoku-on o kiku (Hear alerts and warning sounds)
    MonitorDescription: "テレビを見たり<br/>音楽を聴いたりする", // Terebi o mi tari ongaku o kii tari suru (Watch television and listen to music)
    PhoneDescription: "電話で<br/>会話する", // Denwa de kaiwa suru (Have a conversation on the phone)
    OoOConversationDescription: "１対１で<br/>会話する", // 1 tai 1 de kaiwa suru (Have a one on one conversation)
};

const MoreInfo = {
    Title: "人工内耳のクリニックを探す",
    Description: "より良い聴こえへの次のステップを踏み出しましょう",
};
